/* qeslint-disable */

interface Pointer {
    startx: number;
    starty: number;
    x: number;
    y: number;
    dx: number;
    dy: number;
    offsetx: number;
    offsety: number;
    moved: boolean;
}

type DownCriteria = (pointer: Pointer) => boolean;

export function handleDrag(
    element: HTMLElement,
    ondown: (pointer: Pointer) => void,
    onmove: (pointer: Pointer) => void,
    onup: (pointer: Pointer) => void,
    downCriteria?: DownCriteria
): void {
    let pointer: Pointer | null = null;
    let bounds = element.getBoundingClientRect();

    function handleStart(e: MouseEvent | Touch): void {
        bounds = element.getBoundingClientRect();

        const currentx = e.clientX;
        const currenty = e.clientY;

        pointer = {
            startx: currentx,
            starty: currenty,
            x: currentx,
            y: currenty,
            dx: 0,
            dy: 0,
            offsetx: currentx - bounds.left,
            offsety: currenty - bounds.top,
            moved: false
        };
    }

    function handleMove(e: MouseEvent | Touch): void {
        if (!pointer) {
            return;
        }

        bounds = element.getBoundingClientRect();

        const currentx = e.clientX;
        const currenty = e.clientY;
        const offsetx = currentx - bounds.left;
        const offsety = currenty - bounds.top;

        pointer.x = currentx;
        pointer.y = currenty;
        pointer.dx = e.clientX - pointer.startx;
        pointer.dy = e.clientY - pointer.starty;
        pointer.offsetx = offsetx;
        pointer.offsety = offsety;

        // If the pointer dx/dy is _ever_ non-zero, then it's moved
        pointer.moved = pointer.moved || pointer.dx !== 0 || pointer.dy !== 0;
    }

    function onMouseMove(e: MouseEvent): void {
        handleMove(e);

        if (pointer) {
            onmove(pointer);
        }
    }

    function onMouseUp(e: MouseEvent): void {
        handleMove(e);

        if (pointer) {
            onup(pointer);
        }

        pointer = null;

        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
    }

    function onMouseDown(e: MouseEvent): void {
        handleStart(e);

        if (downCriteria && pointer && !downCriteria(pointer)) {
            pointer = null;

            return;
        }

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);

        if (pointer) {
            ondown(pointer);
        }

        e.preventDefault();
    }

    function onTouchMove(te: TouchEvent): void {
        const e = te.touches[0];

        onMouseMove(e as any);
    }

    function onTouchEnd(e: TouchEvent): void {
        // var e = e.touches[0];
        onMouseUp(e as any);
        element.removeEventListener("touchmove", onTouchMove);
        element.removeEventListener("touchend", onTouchEnd);
    }

    function onTouchStart(te: TouchEvent): void {
        if (te.touches.length === 1) {
            const e = te.touches[0];

            if (downCriteria && !downCriteria(e as any)) {
                return;
            }

            te.preventDefault();
            handleStart(e);

            if (pointer) {
                ondown(pointer);
            }
        }

        element.addEventListener("touchmove", onTouchMove);
        element.addEventListener("touchend", onTouchEnd);
    }

    element.addEventListener("mousedown", onMouseDown);
    element.addEventListener("touchstart", onTouchStart);

    // this.release = function() {
    // 	element.removeEventListener('mousedown', onMouseDown);
    // 	element.removeEventListener('touchstart', onTouchStart);
    // };
}
